import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';

const theme = createTheme();

export const IconButtonComponent: Components = {
  MuiIconButton: {
    styleOverrides: {
      root: {
        height: theme.spacing(4),
        width: theme.spacing(4),
      },
      sizeLarge: {
        height: theme.spacing(6),
        width: theme.spacing(6),
      },
    },
  },
};
